import { useMemo } from 'react';
import type { HypothesisGroup } from '../types/hypothesis';
import { orderByIds } from '../utils/orderByIds';

export type UnpackedOrderByHypothesis = Record<string, string[]>;

interface UseOrderedHypothesisGroupsArgs {
  groups: HypothesisGroup[];
  unpackedOrderByHypothesis: UnpackedOrderByHypothesis;
}

interface UseOrderedHypothesisGroupsResult {
  orderedGroups: HypothesisGroup[];
}

const useOrderedHypothesisGroups = ({
  groups,
  unpackedOrderByHypothesis,
}: UseOrderedHypothesisGroupsArgs): UseOrderedHypothesisGroupsResult =>
  useMemo(
    () => ({
      orderedGroups: groups.map((group) => ({
        ...group,
        creatives: orderByIds(
          group.creatives,
          unpackedOrderByHypothesis[group.hypothesis],
        ),
      })),
    }),
    [groups, unpackedOrderByHypothesis],
  );

export default useOrderedHypothesisGroups;
